import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Importing arrow icons
import { motion } from 'framer-motion';
// import { PieChart } from 'recharts';
// import { Pie } from 'recharts';
import DonutChart from './Donutchart';
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const COLORS = ["#0088FE", "#FF8042", "#00C49F", ];
const headPositionColors = ["#344BFD", "#F68D2B", "#F4A79D"];
const spinePositionColors = ["#344BFD", "#F4A79D", "#F68D2B"];
const handsColors = [ "#00C49F", "#FF8042"];
const eyeBlinkColors = [ "#00C49F","#FF8042", ];
const eyeContactColors = [ "#00C49F", "#FF8042"];
const lipMovementColors = ["#00C49F", "#FF8042"];

const VideoAnalyticsContent = ({ videoData }) => {
  // Default active tab (set to 'head_position' by default)
  const [activeTab, setActiveTab] = useState('head_position');
  const formatValue = (value) => (value ? value.toFixed(1) : '0.0');
  console.log(videoData,'video data')
  // Render content for each active tab
  const renderTabContent = () => {
    switch (activeTab) {
      case 'head_position':
        return (
        <div className="h-full flex flex-col">
          {videoData && videoData.perc.Head_Position && videoData.time.Head_Position ? (
            <>
              {/* Top Section: Animation and Chart (70% height) */}
              <div className="flex flex-row h-[70%]">
                {/* Right - Chart Section */}
                <div className="w-1/2 flex items-center justify-center">
                <DonutChart videoData={videoData.perc.Head_Position} colors={headPositionColors} />
                </div>
                <div className="w-1/3 ml-14 flex items-center justify-center">
                  <img
                    src="/images/Untitled design (6).gif"
                    alt=""
                    className="h-[80%]"
                  />
                </div>
              </div>

              {/* Bottom Section (Remaining 30%) */}
              <div className="flex flex-col items-center justify-center h-[30%]">
                <div className="flex justify-around w-full text-[#767676] text-sm font-medium">
                  <span className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#344BFD]"></span>
                    UpRight Position
                    <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Head_Position.upright_position)} sec */}
                    </span>
                  </span>

                  <span className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#F68D2B]"></span>
                    Slight Bending
                    <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Head_Position.slight_bending)} sec */}
                    </span>
                  </span>
                </div>

                <div className="text-[#767676] text-sm font-medium mt-2 flex justify-center items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#F4A79D]"></span>
                  
                  Extreme Bending
                  <span className="text-[#333] ">
                    {/* {formatValue(videoData.time.Head_Position.extreme_bending)} sec */}
                  </span>
                </div>
              </div>
            </>
          ) : (
            <div className="text-center h-full w-full flex flex-col items-center justify-center">
              <img
                src="/images/No_Search_Result.svg"
                alt="No results"
                className="mx-auto mb-4"
                style={{ width: "200px", height: "auto" }}
              />
              <p className="text-[#8A9ABE]">
                No headposition for face mode
              </p>
            </div>
          )}
        </div>
        );

      case 'spine_position':
        return (
        <div className="h-full flex flex-col">
            {videoData && videoData.perc.Spine_Position && videoData.time.Spine_Position ? (
              <>
                {/* Top Section: Animation and Chart (70% height) */}
                <div className="flex flex-row h-[70%]">
                  {/* Right - Chart Section */}
                  <div className="w-1/2 flex items-center justify-center">
                    <DonutChart videoData={videoData.perc.Spine_Position} colors={spinePositionColors}/>
                  </div>
                  <div className="w-1/3 ml-14 flex items-center justify-center">
                    <img
                      src="/images/Untitled design (7).gif"
                      alt=""
                      className="flex items-center justify-center"
                    />
                  </div>
                </div>

                {/* Bottom Section (Remaining 30%) */}
                <div className="flex flex-col items-center justify-center h-[30%]">
                  <div className="flex justify-around w-full text-[#767676] text-sm font-medium">
                    <span className="flex items-center gap-2">
                      {/* Red Dot for Straight Position */}
                      <span className="w-2 h-2 rounded-full bg-[#344BFD]"></span>
                      Straight
                      <span className="text-[#333]">
                        {/* {formatValue(videoData.time.Spine_Position.straight)} sec */}
                      </span>
                    </span>
                    <span className="flex items-center gap-2">
                      {/* Blue Dot for Slight Slouch */}
                      <span className="w-2 h-2 rounded-full bg-[#F4A79D]"></span>
                      Slight Slouch
                      <span className="text-[#333]">
                        {/* {formatValue(videoData.time.Spine_Position.slight_slouch)} sec */}
                      </span>
                    </span>
                    <span className="flex items-center gap-2">
                      {/* Green Dot for Severe Slouch */}
                      <span className="w-2 h-2 rounded-full bg-[#F68D2B]"></span>
                      Severe Slouch
                      <span className="text-[#333]">
                        {/* {formatValue(videoData.time.Spine_Position.severe_slouch)} sec */}
                      </span>
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center h-full w-full flex flex-col items-center justify-center">
                <img
                  src="/images/No_Search_Result.svg"
                  alt="No results"
                  className="mx-auto mb-4"
                  style={{ width: "200px", height: "auto" }}
                />
                <p className="text-[#8A9ABE]">
                  No spine position for facemode
                </p>
              </div>
            )}
          </div>

        );

      case 'hands':
        return (
            <div className="h-full flex flex-col">
            {/* Top Section: Animation and Chart (70% height) */}
            {videoData && videoData.perc.Hands && videoData.time.Hands ? (
    <>
            <div className="flex flex-row h-[70%] ">
                {/* Left - Animated Section */}
                {/* <motion.div
                    className="w-1/2 flex items-center justify-center bg-gray-100 p-4"
                    animate={{ opacity: [0, 1], scale: [1, 1.1, 1] }}
                    transition={{ duration: 2, repeat: Infinity }}
                >
                    <div className="bg-blue-500 w-20 h-20 rounded-full animate-pulse"></div>
                </motion.div> */}

                {/* Right - Chart Section */}
                <div className="w-1/2 flex items-center justify-center">
                
                    <DonutChart videoData={videoData.perc.Hands} colors={handsColors}/>
                </div>
                <div className="w-1/3 ml-14 flex items-center justify-center ">
                 <img src="/images/Untitled design (8).gif" alt="" className=' flex items-center justify-center'  />
                </div>
            </div>

            <div className="flex flex-col items-center justify-center h-[30%]">
                <div className="flex justify-around w-full text-[#767676] text-sm font-medium">
                <span className="flex items-center gap-2">
                    {/* Red Dot for Upright Position */}
                    <span className="w-2 h-2 rounded-full bg-[#00C49F]"></span>
                    Gesturing <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Hands.Gesturing)} sec */}
                      </span>
                  </span>
                  <span className="flex items-center gap-2">
                    {/* Yellow Dot for Slight Bending */}
                    <span className="w-2 h-2 rounded-full bg-[#FF8042]"></span>
                    Relaxed <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Hands.Relaxed)} sec */}
                      </span>
                  </span>
                </div>
            </div>
            </>): (
                <div className="text-center h-full w-full flex flex-col items-center justify-center">
                  <img
                        src="/images/No_Search_Result.svg"
                        alt="No results"
                        className="mx-auto mb-4"
                        style={{ width: "200px", height: "auto" }}
                      />
                      <p className="text-[#8A9ABE]">
                        No hand gesturing for facemode
                      </p>
                    </div>
                  )}
        </div>
        );

      case 'eye_blink':
        return (
        <div className="h-full flex flex-col">
            {/* Top Section: Animation and Chart (70% height) */}
            {videoData && videoData.perc.Eye_Blink && videoData.time.Eye_Blink ? (
    <>
            <div className="flex flex-row h-[70%]">
                {/* Left - Animated Section */}
                {/* <motion.div
                    className="w-1/2 flex items-center justify-center bg-gray-100 p-4"
                    animate={{ opacity: [0, 1], scale: [1, 1.1, 1] }}
                    transition={{ duration: 2, repeat: Infinity }}
                >
                    <div className="bg-blue-500 w-20 h-20 rounded-full animate-pulse"></div>
                </motion.div> */}

                {/* Right - Chart Section */}
                <div className="w-1/2 flex items-center justify-center">
                    {/* <Pie data={chartData} /> */}
                    <DonutChart videoData={videoData.perc.Eye_Blink} colors={eyeBlinkColors}/>
                </div>
                <div className="w-1/3 ml-14 flex items-center justify-center ">
                 <img src="/images/Untitled design (3).gif" alt="" className=' flex items-center justify-center'  />
                </div>
            </div>
            <div className="flex flex-col items-center justify-center h-[30%]">
                <div className="flex justify-around w-full text-[#767676] text-sm font-medium">
                <span className="flex items-center gap-2">
                    {/* Red Dot for Upright Position */}
                    <span className="w-2 h-2 rounded-full bg-[#FF8042]"></span>
                    Blinking <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Eye_Blink.Blinking)} sec */}
                      </span>
                  </span>
                  <span className="flex items-center gap-2">
                    {/* Yellow Dot for Slight Bending */}
                    <span className="w-2 h-2 rounded-full bg-[#00C49F]"></span>
                    Not Blinking <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Eye_Blink.Not_Blinking)} sec */}
                      </span>
                  </span>
                </div>
            </div>
            </>):(
                <div className="text-center h-full w-full flex flex-col items-center justify-center">
                  <img
                        src="/images/No_Search_Result.svg"
                        alt="No results"
                        className="mx-auto mb-4"
                        style={{ width: "200px", height: "auto" }}
                      />
                      <p className="text-[#8A9ABE]">
                        No eye gesturing for facemode
                      </p>
                    </div>
                  )}
          </div>   
        );

      case 'eye_contact':
        return (
          <div className="h-full flex flex-col">
          {/* Top Section: Animation and Chart (70% height) */}
          {videoData && videoData.perc.Contact && videoData.time.Contact ? (
    <>
          <div className="flex flex-row h-[70%]">
              <div className="w-1/2 flex items-center justify-center">
                  <DonutChart videoData={videoData.perc.Contact} colors={eyeContactColors}/>
              </div>
              <div className="w-1/3 ml-14 flex items-center justify-center ">
              <img src="/images/eyecontect.svg" alt="" className=' flex items-center justify-center'  />
              </div>
          </div>
          <div className="flex flex-col items-center justify-center h-[30%]">
              <div className="flex justify-around w-full text-[#767676] text-sm font-medium">
                 <span className="flex items-center gap-2">
                    {/* Red Dot for Upright Position */}
                    <span className="w-2 h-2 rounded-full bg-[#00C49F]"></span>
                    Eye Contact <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Contact.Eye_Contact)} sec */}
                      </span>
                  </span>
                  <span className="flex items-center gap-2">
                    {/* Yellow Dot for Slight Bending */}
                    <span className="w-2 h-2 rounded-full bg-[#FF8042]"></span>
                    No Eye Contact <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Contact.Not_Eye_Contact)} sec */}
                      </span>
                  </span>
              </div>
          </div>
          </>):(
                <div className="text-center h-full w-full flex flex-col items-center justify-center">
                  <img
                        src="/images/No_Search_Result.svg"
                        alt="No results"
                        className="mx-auto mb-4"
                        style={{ width: "200px", height: "auto" }}
                      />
                      <p className="text-[#8A9ABE]">
                        No eye Contact gesturing for facemode
                      </p>
                    </div>
                  )}
        </div>   
        );

      case 'lip_movement':
        return (
          <div className="h-full flex flex-col">
          {/* Top Section: Animation and Chart (70% height) */}
          {videoData && videoData.perc.Lips && videoData.time.Lips ? (
    <>
          <div className="flex flex-row h-[70%]">
              {/* Left - Animated Section */}
              {/* <motion.div
                  className="w-1/2 flex items-center justify-center bg-gray-100 p-4"
                  animate={{ opacity: [0, 1], scale: [1, 1.1, 1] }}
                  transition={{ duration: 2, repeat: Infinity }}
              >
                  <div className="bg-blue-500 w-20 h-20 rounded-full animate-pulse"></div>
              </motion.div> */}

              {/* Right - Chart Section */}
              <div className="w-1/2 flex items-center justify-center">
                  <DonutChart videoData={videoData.perc.Lips} colors={lipMovementColors}/>
              </div>
              <div className="w-1/3 ml-14 flex items-center justify-center ">
                <img src="/images/Untitled design (4).gif" alt="" className=' flex items-center justify-center'  />
              </div>
          </div>
          <div className="flex flex-col items-center justify-center h-[30%]">
              <div className="flex justify-around w-full text-[#767676] text-sm font-medium">
              <span className="flex items-center gap-2">
                    {/* Red Dot for Upright Position */}
                    <span className="w-2 h-2 rounded-full bg-[#00C49F]"></span>
                    Speaking <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Lips.Speaking)} sec */}
                      </span>
                  </span>
                  <span className="flex items-center gap-2">
                    {/* Yellow Dot for Slight Bending */}
                    <span className="w-2 h-2 rounded-full bg-[#FF8042]"></span>
                    Not Speaking <span className="text-[#333]">
                      {/* {formatValue(videoData.time.Lips.Not_Speaking)} sec */}
                      </span>
                  </span>
                  
              </div>
          </div>
          </>):(
                <div className="text-center h-full w-full flex flex-col items-center justify-center">
                  <img
                        src="/images/No_Search_Result.svg"
                        alt="No results"
                        className="mx-auto mb-4"
                        style={{ width: "200px", height: "auto" }}
                      />
                      <p className="text-[#8A9ABE]">
                        No Lip movement gesturing for facemode
                      </p>
                    </div>
                  )}
        </div>   
        );

      default:
        return <p>No data available for this tab.</p>;
    }
  };

  // Handle toggling of the accordion
  const toggleTab = (tabName) => {
    setActiveTab(activeTab === tabName ? null : tabName); // Toggle between open and close
  };
const sections = [
  "head_position",
  "spine_position",
  "hands",
  "eye_blink",
  "eye_contact",
  "lip_movement",
];

  return (
    <div>
      {/* Accordion for tab headings */}

      {videoData.error ? (
          <div className='w-full h-[500px]  flex items-center justify-center'>
              <div className="text-center h-full w-full flex flex-col items-center justify-center">
                <img
                  src="/images/No_Search_Result.svg"
                  alt="No results"
                  className="mx-auto mb-4"
                  style={{ width: "200px", height: "auto" }}
                />
                <p className="text-[#8A9ABE]">
                {videoData.error}
                </p>
              </div>
          </div>
        ):(
          <div className="accordion">
          {sections.map((section) => (
            <div className="accordion-item" key={section}>
              <div
                className="flex items-center justify-between cursor-pointer p-4"
                onClick={() => toggleTab(section)}
              >
                <span className="font-semibold text-[#303972] capitalize">{section.replace("_", " ")}</span>
                <div className="flex items-center">
                  <span className="ml-2 font-semibold text-[#303972]"></span>
                  <div className="ml-6 p-1 border border-gray-300 rounded-md flex items-center justify-center">
                    {activeTab === section ? (
                      <FaChevronUp className="text-[#303972]" />
                    ) : (
                      <FaChevronDown className="text-[#303972]" />
                    )}
                  </div>
                </div>
              </div>
              {activeTab === section && (
                <div className="border-t border-gray-300 p-4 bg-[#F7F7F7] lg:h-[335px]">
                  {renderTabContent(section)}
                </div>
              )}
            </div>
          ))}
        </div>
        )
      }
      
      
    </div>
  );
};

export default VideoAnalyticsContent;
